import $ from 'jquery';

const tabsNavElements = $('.single-flat-plans-variant:not(.single-flat-plans-variant--external)');
const $changeFlatThumbnailStyleBtn = $('#model-360');

tabsNavElements.on('click', function () {
    let tab_id = $(this).attr('data-plan');

    tabsNavElements.removeClass('is-active');
    $('.single-flat-plan-content').hide();

    $(this).addClass('is-active');
    $(`#${tab_id}.single-flat-plan-content`).show();
})

$changeFlatThumbnailStyleBtn.on('click', function () {
    $(this).next().find('img').hide();
    $(this).next().find('iframe').show();
});


function show360View(element) {
    $(element).find('img').hide();
    $(element).find('iframe').show();
    $(element).off('click mouseover');
}

$(document).ready(function() {
    $('.single-flat-plan-content').on('click mouseover', function() {
        show360View(this);
    });
});